import { Flex, Box, Badge } from '@chakra-ui/react'
import { INSTITUTION_SLUG } from 'constants/index'

interface ModuleContainerProps {
  children: JSX.Element
  institutions: string[]
  category?: 'FEATURE' | 'FIX' | 'ADJUSTMENTS' | 'ADVERTISEMENT'
}

export default function ExclusiveContainer({ children, institutions, category }: ModuleContainerProps) {
  function getText() {
    switch (category) {
      case 'ADVERTISEMENT':
        return 'Anúncio exclusivo'
      case 'ADJUSTMENTS':
        return 'Ajuste exclusivo'
      case 'FEATURE':
        return 'Recurso exclusivo'
      case 'FIX':
        return 'Correção exclusiva'
      default:
        return 'Alteração exclusiva'
    }
  }

  return (
    <Flex
      w="full"
      flexDir="column"
      display={institutions.includes(INSTITUTION_SLUG) ? 'block' : 'none'}
      border="1px solid"
      borderColor="primary"
      p={2}
      rounded="md"
      position={'relative'}
      bg="lightPrimary"
    >
      <Badge colorScheme="primary" pos="absolute" right={'8px'} top={'8px'} zIndex={100}>
        {getText()}
      </Badge>
      <Box w="full">{children}</Box>
    </Flex>
  )
}
